import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsEmbalagClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getEsEmbalag(queries = {}) {
    try {
      const { data } = await this.api.get('/embalagens', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as imagens da home');
    }
  }

  async postEsEmbalag(imagemHome) {
    try {
      return await this.api.post('/embalagens', imagemHome, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      throw this.error.message(error, 'Erro ao salvar a Embalagem');
    }
  }

  async getEsEmbalagById(id) {
    try {
      const { data } = await this.api.get(`/embalagens/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Embalagem');
    }
  }

  async putEsEmbalag(id, imagemHome) {
    try {
      return await this.api.put(`/embalagens/${id}`, imagemHome, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Embalagem');
    }
  }

  async deleteEsEmbalag(id) {
    try {
      return await this.api.delete(`/embalagens/${id}`);
    } catch (error) {
      throw this.error.message(error, 'Erro ao excluir a Embalagem');
    }
  }

  async deleteEsEmbalagSoftDelete(id) {
    try {
      return await this.api.delete(`/embalagens/${id}/softDelete`);
    } catch (error) {
      throw this.error.message(error, 'Erro ao excluir a Embalagem');
    }
  }
}
